@switch (notification.type) { @case ('error') {
<div [id]="'toast-' + notification.type + '-right'" role="alert" style="z-index: 10000;"
  class="fixed flex items-center w-full max-w-xs p-4 space-x-4 text-white bg-red-500 divide-x rtl:divide-x-reverse divide-red-700 rounded-lg shadow top-5 right-5 dark:divide-red-800 space-x dark:bg-red-800">
  <div class="text-sm font-normal">{{ notification.message }}</div>
</div>
}
@case ('info') {
<div [id]="'toast-' + notification.type + '-right'" role="alert" style="z-index: 10000;"
  class="fixed flex items-center w-full max-w-xs p-4 space-x-4 text-white bg-blue-500 divide-x rtl:divide-x-reverse divide-blue-700 rounded-lg shadow top-5 right-5 dark:divide-blue-800 space-x dark:bg-blue-800">
  <div class="text-sm font-normal">{{ notification.message }}</div>
</div>
}
}